import { render, staticRenderFns } from "./Yaoshi.vue?vue&type=template&id=5cd800e4&scoped=true"
import script from "./Yaoshi.vue?vue&type=script&lang=js"
export * from "./Yaoshi.vue?vue&type=script&lang=js"
import style0 from "./Yaoshi.vue?vue&type=style&index=0&id=5cd800e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd800e4",
  null
  
)

export default component.exports